export default __webpack_public_path__ + "static/media/answer_left.eba67cfd.png";